import { render, staticRenderFns } from "./UserPermissionsTable.vue?vue&type=template&id=685eddfa&scoped=true&"
import script from "./UserPermissionsTable.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685eddfa",
  null
  
)

export default component.exports